<template>
  <DropdownSubItem
    label="Marketplace"
    :options="MARKETPLACE_FILTER_OPTIONS"
    :selected-options="selectedOptions"
    @on-apply="onApply"
  />
</template>

<script>
import DropdownSubItem from './DropdownSubItem.vue'
import { MARKETPLACE_FILTER_OPTIONS } from './config'

export default {
  name: 'FilterMarketplace',
  components: {
    DropdownSubItem,
  },
  props: {
    selectedOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      MARKETPLACE_FILTER_OPTIONS,
    }
  },
  methods: {
    onApply(checkedOptions) {
      this.$emit('on-apply', { checkedOptions, label: 'marketplace' })
    },
  },
}
</script>
